/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActivityBadgeCountDto } from '../models/ActivityBadgeCountDto';
import type { CreateActivityInput } from '../models/CreateActivityInput';
import type { CreateSaleInput } from '../models/CreateSaleInput';
import type { FilterActivitiesInput } from '../models/FilterActivitiesInput';
import type { FilterSalesInput } from '../models/FilterSalesInput';
import type { ProjectSaleDtoListResult } from '../models/ProjectSaleDtoListResult';
import type { SaleActivityDto } from '../models/SaleActivityDto';
import type { SaleActivityDtoListResult } from '../models/SaleActivityDtoListResult';
import type { SaleDto } from '../models/SaleDto';
import type { UpdateSaleInput } from '../models/UpdateSaleInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SaleService {

    /**
     * @param version 
     * @param requestBody 
     * @returns ProjectSaleDtoListResult OK
     * @throws ApiError
     */
    public static listSales(
version: string,
requestBody?: FilterSalesInput,
): CancelablePromise<ProjectSaleDtoListResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Sale/Filter',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns SaleActivityDtoListResult OK
     * @throws ApiError
     */
    public static listActivities(
version: string,
requestBody?: FilterActivitiesInput,
): CancelablePromise<SaleActivityDtoListResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Sale/Activities/Filter',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @returns ActivityBadgeCountDto OK
     * @throws ApiError
     */
    public static getBadgeCount(
version: string,
): CancelablePromise<ActivityBadgeCountDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Sale/Activities/Badge/Count',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param id 
     * @param version 
     * @returns SaleDto OK
     * @throws ApiError
     */
    public static getSaleById(
id: number,
version: string,
): CancelablePromise<SaleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Sale/{id}',
            path: {
                'id': id,
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns SaleDto OK
     * @throws ApiError
     */
    public static createSale(
version: string,
requestBody?: CreateSaleInput,
): CancelablePromise<SaleDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Sale',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param saleId 
     * @param version 
     * @param requestBody 
     * @returns SaleDto OK
     * @throws ApiError
     */
    public static updateSale(
saleId: number,
version: string,
requestBody?: UpdateSaleInput,
): CancelablePromise<SaleDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/v{version}/Sale/{saleId}',
            path: {
                'saleId': saleId,
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param saleId 
     * @param version 
     * @returns SaleDto OK
     * @throws ApiError
     */
    public static deleteSale(
saleId: number,
version: string,
): CancelablePromise<SaleDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/user/v{version}/Sale/{saleId}',
            path: {
                'saleId': saleId,
                'version': version,
            },
        });
    }

    /**
     * @param saleId 
     * @param version 
     * @param requestBody 
     * @returns SaleActivityDto OK
     * @throws ApiError
     */
    public static addActivity(
saleId: number,
version: string,
requestBody?: CreateActivityInput,
): CancelablePromise<SaleActivityDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Sale/{saleId}/Activity',
            path: {
                'saleId': saleId,
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param activityId 
     * @param version 
     * @param requestBody 
     * @returns SaleActivityDto OK
     * @throws ApiError
     */
    public static updateActivity(
activityId: number,
version: string,
requestBody?: CreateActivityInput,
): CancelablePromise<SaleActivityDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/v{version}/Sale/Activity/{activityId}',
            path: {
                'activityId': activityId,
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param activityId 
     * @param version 
     * @returns SaleActivityDto OK
     * @throws ApiError
     */
    public static deleteActivity(
activityId: number,
version: string,
): CancelablePromise<SaleActivityDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/user/v{version}/Sale/Activity/{activityId}',
            path: {
                'activityId': activityId,
                'version': version,
            },
        });
    }

}
